import { render, staticRenderFns } from "./Order.view.vue?vue&type=template&id=59c05bee&"
import script from "./Order.view.vue?vue&type=script&lang=js&"
export * from "./Order.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports